<script>
import { orderStatusColorVariant } from '@/sales/filters/statuses';
import EggOrderItems from '@/layer/components/EggOrderItems.vue';

export default {
  filters: {
    orderStatusColorVariant,
  },

  components: {
    EggOrderItems,
  },

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    order: undefined,
    savedOrder: undefined,
  }),

  computed: {
    hasPendingChanges() { return JSON.stringify(this.order) !== JSON.stringify(this.savedOrder); },
    isEditable() { return this.order.status === 'draft' || this.order.status === 'finalized' },
    showCompleteButton() { return this.order.status === 'finalized' },
  },

  methods: {
    cloneOrder() {
      this.savedOrder = JSON.parse(JSON.stringify(this.order));
    },

    onSuccessfulSave(modifiedOrder) {
      this.order = modifiedOrder;
      this.cloneOrder();
    },

    onOrderCompleted() {
      this.$router.push({ name: 'layers/orders/list' })
    },
  },
}
</script>

<template>
  <div>

    <api-loader
      method="get"
      :url="`v1/layers/egg-orders/${encodeURIComponent(id)}`"
      @loaded="order=$event; cloneOrder();" />

    <div v-if="order">
      <b-card no-body>
        <h4 class="text-center my-2"> Order for {{order.date | formatDate('ddd YYYY-MM-DD')}} </h4>

        <b-badge :variant="order.status | orderStatusColorVariant" class="text-uppercase mx-auto mb-3"> {{order.status}} </b-badge>
      </b-card>

      <egg-order-items
        heading="Driver"
        :items="order.items"
        :boxes-and-extra-from-item="item => item.driver"
        :packed-boxes-and-extra-from-item="item => item.driver_packed"
        :disabled="!isEditable"
        class="mt-3" />

      <egg-order-items
        heading="Office"
        :items="order.items"
        :boxes-and-extra-from-item="item => item.office"
        :packed-boxes-and-extra-from-item="item => item.office_packed"
        :disabled="!isEditable"
        class="mt-3" />

      <b-card v-if="isEditable || showCompleteButton" class="mt-3">
        <api-form
          v-if="isEditable"
          method="put"
          :url="`v1/layers/egg-orders/${encodeURIComponent(order.id)}`"
          :payload="order"
          submit-text="Save"
          :make-success-message="() => `Order successfully saved.`"
          @success="onSuccessfulSave"
          hide-cancel>
        </api-form>

        <div v-if="showCompleteButton">
          <confirm-click class="mt-3">
            <api-button
              method="put"
              :url="`v1/layers/egg-orders/${encodeURIComponent(order.id)}/complete`"
              :payload="{ id: order.id }"
              class="btn btn-primary btn-block"
              @executed="onOrderCompleted"
              :disabled="hasPendingChanges">
              Complete Order
            </api-button>
          </confirm-click>
          <div v-if="hasPendingChanges" class="text-warning text-center small"> Save your changes first before completing the Order. </div>
        </div>

      </b-card>

    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggOrder.vue